<div class="flex flex-col justify-between bg-transparent">
  <!-- Drop zone -->
<div
  class="w-full h-40 border-2 bg-white border-dashed rounded-2xl flex flex-col items-center justify-between relative transition cursor-pointer"
  [class.border-blue-500]="isDragging"
  [class.bg-blue-50]="isDragging"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>

  <!-- Eye icon -->
  <div
    class="absolute top-2 right-2 text-gray-400 z-10"
    (click)="onViewFile()"
    (dragover)="$event.stopPropagation()"
    (drop)="$event.stopPropagation()"
    (dragleave)="$event.stopPropagation()"
  >
  </div>

  <!-- Draggable area -->
  <div
    class="flex flex-col items-center justify-center w-full h-full pt-6"
    (click)="triggerFileSelect(fileInput)"
  >
    <input
      id="file-input-{{card}}"
      type="file"
      #fileInput
      class="hidden"
      (change)="onFileSelected($event)"
      [multiple]="isMultiFileCard"
    />

    <mat-icon
      svgIcon="heroicons_outline:upload"
      class="h-10 w-10 text-gray-400 mb-2"></mat-icon>

    <p class="px-2 text-sm text-gray-600 text-center truncate w-full">
      {{ card }}
    </p>
  </div>
</div>

</div>

<div *ngIf="errorMessages.length > 0" class="text-red-600 text-sm my-2">
  <div *ngFor="let msg of errorMessages">{{ msg }}</div>
</div>
